module.exports = __webpack_public_path__ + "static/index-smart-scale-329e7b187f76a879f4ef7d2dc22152b6.png";